import { render, staticRenderFns } from "./Description_mobile.vue?vue&type=template&id=8346a188&scoped=true&"
import script from "./Description_mobile.vue?vue&type=script&lang=js&"
export * from "./Description_mobile.vue?vue&type=script&lang=js&"
import style0 from "./Description_mobile.vue?vue&type=style&index=0&id=8346a188&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8346a188",
  null
  
)

export default component.exports